import KeyMirror from 'keymirror'

const DefinitionTypes = KeyMirror({
	SET_TERM: null,
	SET_DEFINITION_VN: null,
	SET_DEFINITION_EN: null,
	SET_DEFINITION_LOADING: null,
	SET_DEFINITION: null,
	RESET_DEFINITION: null,
	SET_WORD_TYPE: null,
	// word
	UPDATE_DICT_WORD_IN_DETAIL: null,
})

export default DefinitionTypes
